module.exports = __webpack_public_path__ + "static/media/turkey@2x.7300c5ab.jpg";